/*
* 网站配置文件
* */
var config = {
  appName: '商户平台',
  appLogo: '',
  poweredBy: '',
  copyRight: ''
};
export default config;